import { FleetEventUIDto, IFleetEventUIDto } from "@/lib/dto/event/event-ui.dto";
import { PageFilterTypes } from "@/lib/utility/data/page-filter-types.enum";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import eventFleetService from "@/services/mrfiktiv/services/fleet/eventFleetService";
import { BaseStore } from "@/store/base.store";
import store from "@/store/VuexPlugin";
import { Action, Module, getModule } from "vuex-module-decorators";
import { FleetEventDataAccessLayer } from "../access-layers/fleet-event.access-layer";
import { PaginationFilterListElement } from "../base-pagination.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "overdueEventFleetStore",
  store
})
export class OverdueEventFleetStore extends BaseStore<IFleetEventUIDto> {
  _data = FleetEventDataAccessLayer;

  hiddenFilter = [
    new PageFilterElement({
      key: "isOverdue",
      value: true as any
    })
  ];

  filterOptions: PaginationFilterListElement[] = [
    { key: "summary", type: PageFilterTypes.STRING, displayName: "objects.event.summary" },
    { key: "description", type: PageFilterTypes.STRING, displayName: "objects.event.description" },
    { key: "start", type: PageFilterTypes.DATE, displayName: "objects.event.start" },
    { key: "end", type: PageFilterTypes.DATE, displayName: "objects.event.end" }
  ].map((f) => new PaginationFilterListElement(f));

  @Action
  async fetchAll(data: { partnerId: string; fleetId: string }) {
    const events = (await eventFleetService.findOverdue(data.partnerId, data.fleetId)) ?? [];

    for (const event of events) {
      this._data.set(new FleetEventUIDto(event));
    }

    return events;
  }
}

export const OverdueEventFleetModule = getModule(OverdueEventFleetStore);
